module.exports = __webpack_public_path__ + "img/PDM-600_GUI_v1.3.0.f2798e46.webp";